/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Empty_DescriptionInputs */

const id_reseller_pricing_empty_description = /** @type {(inputs: Reseller_Pricing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLD muncul di sini begitu KilatDomain menawarkannya.`)
};

const en_reseller_pricing_empty_description = /** @type {(inputs: Reseller_Pricing_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLDs show here as soon as KilatDomain offers them.`)
};

/**
* | output |
* | --- |
* | "TLDs show here as soon as KilatDomain offers them." |
*
* @param {Reseller_Pricing_Empty_DescriptionInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_empty_description = /** @type {((inputs?: Reseller_Pricing_Empty_DescriptionInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Empty_DescriptionInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_empty_description(inputs)
	return id_reseller_pricing_empty_description(inputs)
});